export class ProviderNotes
{
    static readonly arkiaNotes:string[] = 
    [
        'למימוש כרטיס טיסה ביולי-אוגוסט יש לרכוש כרטיס מסוג סוף שבוע'
    ];

    static readonly israirNotes:string[] = 
    [
        'למימוש כרטיס טיסה ביולי יש לרכוש כרטיס מסוג סוף שבוע'
    ];
}